import { Form, Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Link } from "react-router-dom";
import showNotification from "../../components/notification/showNotification";
import { createReel } from "../../action/shorts";

const CreateShortVideo = () => {
  const navigate = useNavigate();
  const [videoUploading, setVideoUploading] = useState(false);
  const [videoPreview, setVideoPreview] = useState(null);
  const addFormik = useFormik({
    initialValues: {
      desc: { en: "", hi: "", mr: "" },
      categoryId: "",
      file: "",
      duration: 0,
    },
    onSubmit: async (values) => {
      setVideoUploading(true);
      const formData = new FormData();

      // append video
      formData.append("file", values.file);

      // append desc object
      const desc = {
        en: values.desc.en,
        hi: values.desc.hi,
        mr: values.desc.mr,
      };
      formData.append("desc", JSON.stringify(desc));
      formData.append("categoryId", values.categoryId);
      formData.append("duration", values.duration);
      const res = await createReel(formData);
      if (res.status) {
        showNotification("Success", res.message, "success");
        navigate("/shorts/list");
      } else {
        showNotification("Error", res.message, "danger");
      }
      setVideoUploading(false);
    },
  });

  useEffect(() => {
    return () => {
      if (videoPreview) {
        URL.revokeObjectURL(videoPreview);
      }
    };
  }, [videoPreview]);

  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top">
          <div className="payout_data-left">
            <div className="">
              {" "}
              <Breadcrumb
                paths={[
                  {
                    name: "Shorts",
                    link: `/shorts/list`,
                  },
                  { name: "Add Shorts", link: "/shorts/add" },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tab_box">
        <Formik>
          <Form onSubmit={addFormik.handleSubmit} className="">
            <div className="row">
              <div className="col-md-6">
                <div className="input-box">
                  <div className="input-label">Caption Title (English)</div>
                  <div className="input_field">
                    <textarea
                      required
                      className="input"
                      name="desc.en"
                      placeholder="Enter caption"
                      value={addFormik.values.desc.en}
                      onChange={addFormik.handleChange}
                      rows={3}
                    />
                  </div>
                </div>
                <div className="input-box mt-3">
                  <div className="input-label">Caption Title (Hindi)</div>
                  <div className="input_field">
                    <textarea
                      required
                      className="input"
                      name="desc.hi"
                      placeholder="Enter caption"
                      value={addFormik.values.desc.hi}
                      onChange={addFormik.handleChange}
                      rows={3}
                    />
                  </div>
                </div>

                <div className="input-box mt-3">
                  <div className="input-label">Caption Title (Marathi)</div>
                  <div className="input_field">
                    <textarea
                      required
                      className="input"
                      name="desc.mr"
                      placeholder="Enter caption"
                      value={addFormik.values.desc.mr}
                      onChange={addFormik.handleChange}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-box">
                  <div className="input-label">Upload Video</div>
                  <div className="mt-3">
                    <input
                      required
                      type="file"
                      accept="video/*"
                      onChange={(e) => {
                        const file = e.currentTarget.files[0];
                        if (!file) return;

                        if (!file.type.startsWith("video/")) {
                          showNotification("Error", "Only video files are allowed!", "danger");

                          e.target.value = null;
                          addFormik.setFieldValue("file", null);
                          setVideoPreview(null);
                          return;
                        }

                         const maxSize = 100 * 1024 * 1024; // 100MB in bytes
                        if (file.size > maxSize) {
                          showNotification("Error", "Video size must be less than 100 MB", "danger");

                          e.target.value = null;
                          addFormik.setFieldValue("file", null);
                          setVideoPreview(null);
                          return;
                        }

                        addFormik.setFieldValue("file", file);

                        const previewUrl = URL.createObjectURL(file);
                        setVideoPreview(previewUrl);

                        const video = document.createElement("video");
                        video.preload = "metadata";

                        video.onloadedmetadata = () => {
                          window.URL.revokeObjectURL(video.src);
                          if (video.duration > 60) {
                            addFormik.setFieldValue("file", null);
                            setVideoPreview("");
                          addFormik.setFieldValue("duration", 0);
                            showNotification("Error", "Video duration must be 60 seconds or less", "danger");
                            return;
                          }
                          const durationInSeconds = Math.round(video.duration);
                          addFormik.setFieldValue("duration", durationInSeconds);
                        };

                        video.src = previewUrl;
                      }}
                    />

                    {videoPreview && (
                      <div className="input-box">
                        <div className="input-label">Video Preview</div>

                        <video
                          src={videoPreview}
                          controls
                          style={{
                            width: "100%",
                            maxHeight: "400px",
                            borderRadius: "10px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div>
                <div className="input-box ">
                  <div className="flex_btn">
                    <Link
                      className="btn btn-info addbbtn"
                      style={{ color: "white" }}
                      // color="red"
                      to={videoUploading ? "#" : "/shorts/list"}
                    >
                      <i className="fas fa-arrow-left"></i>
                      &nbsp;&nbsp; Back
                    </Link>
                    <button
                      className="btn btn-success"
                      type="submit"
                      disabled={videoUploading || !addFormik.values.duration}
                    >
                      {videoUploading ? "Submitting" : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default CreateShortVideo;
